export const MuiChip = {
    defaultProps: {
        variant: 'outlined',
        size: 'small'
    },
    styleOverrides: {
        sizeSmall: {
            height: '18px'
        },
        sizeMedium: {
            height: '24px'
        },
        deleteIcon: ({ theme })=>{
            return theme.palette.mode === 'light' ? {
                color: theme.palette.grey[400]
            } : {
                color: theme.palette.designSystem.grey[300]
            };
        },
        outlined: ({ theme })=>({
                borderColor: theme.palette.mode === 'light' ? theme.palette.designSystem.grey[600] : 'white'
            }),
        icon: ({ theme })=>({
                color: theme.palette.text.primary,
                width: '12px',
                height: '12px'
            }),
        iconColorPrimary: ({ theme })=>({
                color: theme.palette.mode === 'light' ? 'white' : 'black'
            }),
        iconSmall: ({ theme })=>({
                marginLeft: theme.spacing(1)
            }),
        iconMedium: ({ theme })=>({
                marginLeft: theme.spacing(1.5)
            }),
        labelSmall: {
            fontSize: '12px'
        }
    }
};

//# sourceMappingURL=chip-overrides.js.map